import React from 'react';
import UserAvatar from 'components/pure/utils/UserAvatar';
import './PlanUserAvatars.styl';

export default class PlanUserAvatars extends React.PureComponent {
  render() {
    const {coach, recipient} = this.props;

    if (!coach || !recipient) return null;

    return (
      <div className="plan-user-avatars">
        <UserAvatar key={coach.id} user={coach} enableTooltip={true} tooltipDirection="top" />
        <UserAvatar
          key={recipient.id}
          user={recipient}
          enableTooltip={true}
          tooltipDirection="top"
        />
      </div>
    );
  }
}
